exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GxQH{clear:both;width:100%}._3gk0S{text-align:center;margin:10px 0 5px;color:#b8b8b8;font-size:16px}", ""]);

// exports
exports.locals = {
	"loadMore": "_1GxQH",
	"loadText": "_3gk0S"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/common/LoadMore/index.css
// module id = 889
// module chunks = 2 3 4 7 8